import { cn } from "@babybjorn/ui";
import { forwardRef, type HTMLAttributes, type PropsWithChildren } from "react";
import * as s from "./GridItem.module.scss";

type GridItemProps = HTMLAttributes<HTMLDivElement> &
	PropsWithChildren<{
		fullWidth?: boolean;
	}>;

const GridItem = forwardRef<HTMLDivElement, GridItemProps>(
	({ children, fullWidth, ...rest }, ref) => {
		return (
			<div
				className={cn(s.item, { [s.fullWidth]: fullWidth })}
				{...rest}
				ref={ref}
			>
				{children}
			</div>
		);
	},
);

GridItem.displayName = "GridItem";

export default GridItem;
